import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=ca8efcb2&scoped=true"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"
import style0 from "./Type.vue?vue&type=style&index=0&id=ca8efcb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8efcb2",
  null
  
)

export default component.exports